export const yearFromToMixin = {
    props: {
        yearFrom: [String, Number],
        yearTo: [String, Number],
    },
    computed: {
        yearsRange() {
            if (!this.yearFrom || !this.yearTo) return "";
            if (this.yearFrom === this.yearTo) return `${this.yearFrom}`;
            return `${this.yearFrom} – ${this.yearTo}`;
        },
    },
};
